module.exports = __webpack_public_path__ + "static/media/Dataanalytics.736714ac.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/Wickey/Dataanalytics.jpg
// module id = 372
// module chunks = 0